import _extends from '../../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { CircularProgress } from '@material-ui/core';

var _excluded = ["children", "color", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "endIcon", "fullWidth", "href", "onClick", "size", "startIcon", "variant", "white", "onBlur", "onFocus", "loading", "className", "buttonRef"];
var useStyles = makeStyles(function (theme) {
  return {
    buttonWrapper: {
      position: "relative"
    },
    button: {
      margin: theme.spacing(1)
    },
    small: {
      fontSize: theme.spacing(1.75),
      padding: theme.spacing(1.5, 2),
      height: theme.spacing(4.5)
    },
    medium: {
      fontSize: theme.spacing(1.75),
      padding: theme.spacing(1.75, 3),
      height: theme.spacing(5)
    },
    large: {
      fontSize: theme.spacing(2),
      padding: theme.spacing(2.25, 4),
      height: theme.spacing(6)
    },
    white: {
      background: theme.palette.grey["0"] + " !important",
      color: theme.palette.text.black + " !important",
      border: "none !important"
    },
    whiteText: {
      color: theme.palette.text.white + " !important",
      border: "none !important"
    },
    disabled: {
      background: theme.palette.grey["100"] + " !important",
      borderRadius: "6px",
      color: theme.palette.text.disabledStrong + " !important",
      border: "none !important"
    },
    textDisabled: {
      background: "unset !important"
    },
    hidden: {
      visibility: "hidden"
    },
    blackText: {
      // TODO: according to the designs the color is not total black, but the primary one and there is no border
      // color: theme.palette.black + " !important",
      "&:hover": {
        // border: "1px solid" + theme.palette.secondary["200"],
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        borderRadius: theme.spacing(0.75)
      }
    },
    greyText: {
      color: theme.palette.secondary["900"] + " !important",
      borderRadius: theme.spacing(0.75),
      border: "1px solid" + theme.palette.secondary["900"],
      "&:hover": {
        backgroundColor: "rgba(119, 110, 98, 0.08)"
      }
    },
    negative: {
      border: "1px solid " + theme.palette.grey[0],
      color: theme.palette.grey[0] + " !important",
      "&:hover": {
        border: "1px solid" + theme.palette.secondary["200"],
        backgroundColor: "rgba(255, 255, 255, 0.08)"
      }
    },
    danger: {
      "&.outlined": {
        color: theme.palette.error.danger,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
          borderRadius: theme.spacing(0.75)
        }
      },
      "&.contained": {
        backgroundColor: theme.palette.error.danger,
        "&:hover": {
          backgroundColor: "#cf4445"
        }
      }
    }
  };
});
var CustomButton = function CustomButton(_ref) {
  var children = _ref.children,
    color = _ref.color,
    disabled = _ref.disabled,
    disableElevation = _ref.disableElevation,
    disableFocusRipple = _ref.disableFocusRipple,
    disableRipple = _ref.disableRipple,
    endIcon = _ref.endIcon,
    fullWidth = _ref.fullWidth,
    href = _ref.href,
    onClick = _ref.onClick,
    size = _ref.size,
    startIcon = _ref.startIcon,
    variant = _ref.variant,
    white = _ref.white,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    loading = _ref.loading,
    className = _ref.className,
    buttonRef = _ref.buttonRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var handleClick = function handleClick() {
    if (onClick && !loading) {
      onClick();
    }
  };
  var handleFocus = function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  };
  var handleBlur = function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  };
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
    className: clsx(className, variant, classes.buttonWrapper, _defineProperty({}, classes.small, size === "small"), _defineProperty({}, classes.medium, size === "medium"), _defineProperty({}, classes.large, size === "large"), _defineProperty({}, classes.white, white), _defineProperty({}, classes.whiteText, color === "whiteText"), _defineProperty({}, classes.negative, color === "negative"), _defineProperty({}, classes.blackText, color === "black"), _defineProperty({}, classes.danger, color === "danger"), _defineProperty({}, classes.greyText, color === "grey"), _defineProperty({}, classes.disabled, disabled), _defineProperty({}, classes.textDisabled, disabled && variant === "text")),
    color: color !== "black" && color !== "negative" && color !== "danger" && color !== "grey" ? color : "default",
    disabled: disabled,
    disableElevation: disableElevation,
    disableFocusRipple: disableFocusRipple,
    disableRipple: disableRipple,
    endIcon: !loading && endIcon,
    fullWidth: fullWidth,
    href: href,
    size: size,
    startIcon: !loading && startIcon,
    variant: variant,
    onClick: handleClick,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: buttonRef
  }), loading && /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 22,
    thickness: 4.5,
    color: "inherit",
    style: {
      position: "absolute"
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(_defineProperty({}, classes.hidden, loading))
  }, children));
};
CustomButton.defaultProps = {
  color: "primary",
  disabled: false,
  size: "medium",
  variant: "text",
  white: false,
  loading: false
};
CustomButton.propTypes = {
  children: PropTypes__default.any,
  color: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  disableElevation: PropTypes__default.bool,
  disableFocusRipple: PropTypes__default.bool,
  disableRipple: PropTypes__default.bool,
  endIcon: PropTypes__default.element,
  fullWidth: PropTypes__default.bool,
  href: PropTypes__default.string,
  size: PropTypes__default.oneOf(["small", "medium", "large"]),
  startIcon: PropTypes__default.element,
  variant: PropTypes__default.string,
  onClick: PropTypes__default.func,
  className: PropTypes__default.string,
  buttonRef: PropTypes__default.any,
  white: PropTypes__default.bool,
  onBlur: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  loading: PropTypes__default.bool
};

export { CustomButton as default };
//# sourceMappingURL=CustomButton.js.map
